<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableElasticResourceListData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableElasticResourceVue = {};
export default {
  name: "TableElasticResource",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountNameSearchIDVal: "",
      columns: [
        {
          title: this.$t("RAM.AWS.ElasticIP.accountName"),
          key: "accountName"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.accountID"),
          key: "accountIdString"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.title"),
          key: "publicIp"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.allocatedID"),
          key: "allocationId"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.privateIP"),
          key: "privateIp"
        },
        {
          title: this.$t("RAM.AWS.ElasticIP.AttachedInstance"),
          key: "instanceId"
        }
      ],
      tableElasticResourceListData: [],
      accountNameSearchIDVal: ""
    };
  },
  beforeCreate: function() {
    tableElasticResourceVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("accountNameSearchID", function(accountNameSearchIDVal) {
      tableElasticResourceVue.accountNameSearchIDVal = accountNameSearchIDVal;
    });
    eventBus.$on("companyId", function(companyId) {
      tableElasticResourceVue.companyId = companyId;
    });
  },
  mounted: function() {
    // tableElasticResourceVue.getElasticResourceListData();
  },
  methods: {
    showAll: function() {
      tableElasticResourceVue.getElasticResourceListData();
    },
    // 分页显示数据
    /****************************************************/
    getElasticResourceListData: function() {
      this.$api.resourceManagement
        .selectAWSEipByPage({
          pageNum: this.current,
          pageSize: this.pageSize,
          companyId: this.companyId,
          accountName: this.accountNameSearchIDVal
        })
        .then(res => {
          this.tableElasticResourceListData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableElasticResourceVue.getElasticResourceListData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableElasticResourceVue.getElasticResourceListData();
    },
    // 销毁caseSearchID
    beforeDestroy: function() {
      eventBus.$off("accountNameSearchID");
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/eip/TableElasticResource.vue